export enum TipOptionEnum {
  option1 = 'option1',
  option2 = 'option2',
  option3 = 'option3',
}

export interface ITipOptions {
  [TipOptionEnum.option1]: number;
  [TipOptionEnum.option2]: number;
  [TipOptionEnum.option3]: number;
}
export interface ITipState {
  tipOptions: ITipOptions;
  tipToggle: boolean;
}
export enum LoadingIndicator {
  pending = 'pending',
  completed = 'completed',
  error = 'error',
}

export interface ITipSettingsProvider extends ITipState {
  updateTipToggle: (val: boolean) => void;
  loadingState: LoadingIndicator;
  updateTipConfiguration: (val: ITipState) => void;
}
export interface ITipConfigurationApi extends ITipOptions {
  enabled: boolean;
}
